export const QcTooltipName = 'qcTooltipComponent';
